import { gql } from '@apollo/client';

const NewsletterQueryEn = gql`
query MyQuery {
  nodeSimplenewsIssues(first: 100, langcode: "en") {
    nodes {
      title
      __typename
      typeOfNewsletter {
        ... on TermNewsletterTypeOld {
          id
          name
        }
      }
      shortDescription
      oldNewsletterPdf {
        ... on MediaOldNewsletterPdf {
          id
          name
          mediaFile {
            url
            name
          }
        }
      }
      newsletterCoverImage {
        ... on MediaNewsletterCoverImage {
          id
          name
          mediaImage6 {
            url
            alt
          }
        }
      }
      bannerImage {
        title
        url
        alt
      }
      newsletterDescription {
        value
      }
      path
      created {
        time
      }
      sectionOneTemplate {
        ... on Paragraph2PartWithImage {
          id
          partOne {
            ... on ParagraphTitleDescriptionAndImage {
              id
              titleAndDescription {
                ... on ParagraphTitleAndDescription {
                  id
                  title
                  descriptions {
                    value
                  }
                }
              }
              image {
                ... on MediaNewsletterMedia {
                  id
                  name
                  mediaImage5 {
                    url
                    title
                    alt
                  }
                }
              }
            }
          }
          partTwo {
            ... on ParagraphTitleDescriptionAndImage {
              id
              image {
                ... on MediaNewsletterMedia {
                  id
                  name
                  mediaImage5 {
                    title
                    url
                    alt
                  }
                }
              }
              titleAndDescription {
                ... on ParagraphTitleAndDescription {
                  id
                  title
                  descriptions {
                    value
                  }
                }
              }
            }
          }
        }
      }
      sectionTwoTemplate {
        ... on ParagraphTitleDescriptionAndImage {
          id
          image {
            ... on MediaNewsletterMedia {
              id
              name
              mediaImage5 {
                url
                alt
                title
              }
            }
          }
          titleAndDescription {
            ... on ParagraphTitleAndDescription {
              id
              title
              descriptions {
                value
              }
            }
          }
        }
      }
      sectionThreeTemplate {
        ... on Paragraph2PartWithImage {
          id
          partOne {
            ... on ParagraphTitleDescriptionAndImage {
              id
              titleAndDescription {
                ... on ParagraphTitleAndDescription {
                  id
                  title
                  descriptions {
                    value
                  }
                }
              }
              image {
                ... on MediaNewsletterMedia {
                  id
                  name
                  mediaImage5 {
                    url
                    title
                    alt
                  }
                }
              }
            }
          }
          partTwo {
            ... on ParagraphTitleDescriptionAndImage {
              id
              image {
                ... on MediaNewsletterMedia {
                  id
                  name
                  mediaImage5 {
                    title
                    url
                    alt
                  }
                }
              }
              titleAndDescription {
                ... on ParagraphTitleAndDescription {
                  id
                  title
                  descriptions {
                    value
                  }
                }
              }
            }
          }
        }
      }
      programHighlightsTitle
      programHighlightsColumn
      programTwoColumn
      programHighlightsTableD {
        ... on ParagraphProgramHighlightsTableDatum {
          id
          columnOne
          columnTwo
        }
      }
      teamCornerMainTitle
      teamCornerSection {
        ... on ParagraphTitleDescriptionAndImage {
          id
          titleAndDescription {
            ... on ParagraphTitleAndDescription {
              id
              title
              descriptions {
                value
              }
            }
          }
          image {
            ... on MediaNewsletterMedia {
              id
              name
              mediaImage5 {
                alt
                url
                title
              }
            }
          }
        }
      }
      upcomingPlan
      upcomingPlanPoints
    }
  }
}
`;
export default NewsletterQueryEn;
